<div
  class="flex w-full flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-warning-100 px-3 py-2 text-center text-sm text-warning-800 dark:bg-warning-500/20 dark:text-warning-300"
  role="status"
  data-testid="switch-user-banner"
>
  <span>You are viewing as <strong class="font-semibold">{{ viewingAsName }}</strong>.</span>
  <button
    type="button"
    class="font-semibold underline underline-offset-2 hover:no-underline disabled:opacity-50"
    [disabled]="switchingBack"
    (click)="switchBack()"
  >
    {{ switchingBack ? 'Switching back…' : 'Switch back' }}
  </button>
</div>
